import { render, staticRenderFns } from "./PrescriptionAdd.vue?vue&type=template&id=8cdb8fb8&"
import script from "./PrescriptionAdd.vue?vue&type=script&lang=js&"
export * from "./PrescriptionAdd.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionAdd.vue?vue&type=style&index=0&id=8cdb8fb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports